/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationResourceScheduleDetails {
    getFixupPrototypeFunction() { return ScheduleRecommendationResourceScheduleDetails.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationResourceScheduleDetails>): ScheduleRecommendationResourceScheduleDetails {
        let obj = Object.assign(new ScheduleRecommendationResourceScheduleDetails(), model);
        ScheduleRecommendationResourceScheduleDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationResourceScheduleDetails>): ScheduleRecommendationResourceScheduleDetails {
        if (!model) return null;
        return ScheduleRecommendationResourceScheduleDetails.newInstance(<ScheduleRecommendationResourceScheduleDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationResourceScheduleDetails) {
        if (!obj) return;

        models.ScheduleRecommendationResourceScheduleDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationResourceScheduleDetails): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationResourceScheduleDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.potential_cost_savings_daily === undefined) {
            this.potential_cost_savings_daily = 0;
        }
        if (this.potential_cost_savings_monthly === undefined) {
            this.potential_cost_savings_monthly = 0;
        }
        if (this.potential_cost_savings_yearly === undefined) {
            this.potential_cost_savings_yearly = 0;
        }
    }

    /**
     * Schedule Recommendation ID
     */
    schedule_recommendation_id: string;

    /**
     * Service Resource Inventory Id
     */
    service_resource_inventory_id: string;

    /**
     * Cloud Resource Identifier
     */
    resource_id: string;

    /**
     * Name of the resource
     */
    resource_name: string;

    /**
     * Name of the resource component
     */
    resource_type: string;

    /**
     * Currency
     */
    currency: models.Currency;

    /**
     * recommendation confidence based on statistical method
     */
    info: string;

    /**
     * Daily Cost Savings
     */
    potential_cost_savings_daily: number;

    /**
     * Monthly Cost Savings
     */
    potential_cost_savings_monthly: number;

    /**
     * Yearly Cost Savings
     */
    potential_cost_savings_yearly: number;

    /**
     * Schedule Finding Type
     */
    schedule_finding: models.ScheduleFinding;

    /**
     * Schedule Recommendation Statistical Method Name
     */
    statistical_method: models.ScheduleRecommendationStatisticalMethod;

}
